import QuestionDetailsNode from 'pages/Flow/Nodes/QuestionNode/QuestionDetailsNode';
import QuestionSetUpNode from 'pages/Flow/Nodes/QuestionNode/QuestionSetUpNode';
import React, {
  memo, useCallback,
} from 'react';
import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { setCreateNode } from 'redux/actions/FlowAction';
import { useDispatch, useSelector } from 'react-redux';


export const QuestionNode = memo(({
  type, xPos, yPos, ...props
}) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);
  const flow = useSelector(state => state.flow.flow);
  const crFlow = useSelector(state => state.flow.cleanRoomFlow);
  const nodes = useSelector(state => state.flow.nodes);
  const qNode = useSelector(state => state.flow.nodes.find(i => i.id === props.id));
  const cleanRoom = useSelector(state => state.cleanRooms.detail);

  const composeNodeLabel = useCallback((question) => {
    const amountOfNodesSharingQuestion = nodes.filter((node) => (
      node?.data?.referenceID === question.ID
    )).length;
    return `${question?.displayID}_${amountOfNodesSharingQuestion + 1}`;
  }, [nodes]);

  const onQuestionSelection = (selectedQuestion) => {
    const nodePayload = {
      node: {
        label: composeNodeLabel(selectedQuestion),
        nodeType: type,
        referenceID: selectedQuestion.ID,
        positionX: parseInt(xPos, 10),
        positionY: parseInt(yPos, 10),
      },
      cleanRoomID: cleanRoom?.ID || '',
    };

    dispatch(setCreateNode({
      orgId,
      crId: cleanRoom?.ID,
      flowID: flow.ID,
      crFlowId: crFlow.ID,
      nodeId: props.id,
      nodePayload,
      isEditable: selectedQuestion?.isEditable,
    }));
  };

  if (!qNode) {
    return null;
  }

  return (
    <>
      {qNode?.data?.referenceID ? (
        <QuestionDetailsNode
          nodeId={props.id}
          qId={qNode.data.referenceID}
          qNode={qNode}
          {...props}
        />
      ) : (
        <QuestionSetUpNode onQuestionAdd={onQuestionSelection} {...props} />
      )}
    </>
  );
});
